'use strict';

module.exports.profilePriorities = ['Low', 'Medium', 'High'];

module.exports.profileStates = ['Info Request Sent', 'Info Received', 'In Progress', 'Pre Profile Completed', 'Profile Stalled', 'Profile Approved'];

module.exports.recoGuidance = ['Venue Partner', 'On-Boarding', 'PVP', 'On Hold', 'PVP Booked', 'Stalled Partner', 'Venue Closed', 'Venue Lost', 'Venue Quit', 'Bad Fit'];

module.exports.bookingCutoff = 60;

module.exports.newVenueCutoff = 90;

module.exports.network = ['Dinova'];